export default function TierBadge({ tier }) {
  if (!tier) {
    return <span className="text-[#9CA3AF] font-mono text-[10px] uppercase">—</span>;
  }
  const map = {
    small: { bg: "#2a2a2a", text: "#bababa", label: "Small" },
    medium: { bg: "#1c2a4d", text: "#8aa9ff", label: "Medium" },
    premium: { bg: "#3d2310", text: "#8cb62c", label: "🏆 Premium" },
  };
  const c = map[tier] || map.small;
  return (
    <span
      style={{ background: c.bg, color: c.text }}
      className="px-2 py-1 font-mono text-[10px] uppercase tracking-wider whitespace-nowrap"
      data-testid={`tier-badge-${tier}`}
    >
      {c.label}
    </span>
  );
}
